"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreloadDataService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
function updateByKey(toUpdate, values, propName) {
    if (!toUpdate || !values || !propName)
        return;
    if (Object.prototype.hasOwnProperty.call(values, propName)) {
        toUpdate[propName] = values[propName];
    }
}
function updateCacheForApplicationService() {
    // TODO, clear cache for ApplicationApiService.getApplicationInfo
    // const url = await this.jsonApiService.getApiUrl('ApplicationService', 'application');
    // return this.httpService.post<IServiceResult<IApplication>>(url, { test: true }, { cache: 'session' });
}
function updateGlobalBrandSetting(preloadData, values) {
    if (preloadData) {
        var globalBrandSetting = preloadData.application.System.SystemOptions.GlobalBrandSetting;
        updateByKey(globalBrandSetting.ThemeColor, values, 'PrimaryColor');
        updateByKey(globalBrandSetting.ThemeColor, values, 'SecondaryColor');
        updateByKey(globalBrandSetting, values, 'CustomLogoBlobId');
    }
    else {
        updateCacheForApplicationService();
    }
}
function updateUser(preloadData, values) {
    if (preloadData) {
        var user = preloadData.application.User;
        updateByKey(user, values, 'CustomPropertyText');
    }
    else {
        updateCacheForApplicationService();
    }
}
function updateSystemOption(preloadData, values) {
    if (preloadData) {
        var systemOptions = preloadData.application.System.SystemOptions;
        updateByKey(systemOptions, values, 'SessionTimeoutMinutes');
    }
    else {
        updateCacheForApplicationService();
    }
}
var PreloadDataService = /** @class */ (function () {
    function PreloadDataService() {
    }
    /**
     * Remember that it's a underground preload mechanism and aiming for improving
     * the performance, it should only be used in bundle and seismic-common.
     * In another word, you should never use it in your feature repos.
     * @returns IAppData | undefined
     */
    PreloadDataService.prototype.getPreloadData = function () {
        return window.appDatas;
    };
    /**
     * Only used for GlobalBrandSetting, use and systemOption's SessionTimeoutMinutes for now
     * @param type
     * @param values
     */
    PreloadDataService.prototype.updatePreloadData = function (type, values) {
        var preloadData = this.getPreloadData();
        switch (type) {
            case 'GlobalBrandSetting': {
                updateGlobalBrandSetting(preloadData, values);
                break;
            }
            case 'User': {
                updateUser(preloadData, values);
                break;
            }
            case 'SystemOption': {
                updateSystemOption(preloadData, values);
                break;
            }
            default:
                console.error('PreloadDataService.updatePreloadCache is only supporting "GlobalBrandSetting" and "User" as type for now, input type =', type);
                break;
        }
    };
    PreloadDataService = __decorate([
        CommonService_decorator_1.CommonService('PreloadDataService')
    ], PreloadDataService);
    return PreloadDataService;
}());
exports.PreloadDataService = PreloadDataService;
//# sourceMappingURL=PreloadData.service.js.map